export enum AblyGoodsCardSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
}
